import { Button as ChakraButton, ButtonProps as ChakraButtonProps, forwardRef, useStyleConfig } from '@chakra-ui/react';
import { ColorScheme } from '../../types/bitkit';

export interface ColorButtonProps extends ChakraButtonProps {
  as?: 'a' | 'button';
  colorScheme?: ColorScheme;
}

/**
 * The ColorButton component is used to trigger an action or event, such as submitting a form, opening a dialog, canceling an action, or performing a delete operation.
 */
const ColorButton = forwardRef<ColorButtonProps, 'button'>((props, ref) => {
  const { as = 'button', colorScheme, isDisabled, isLoading, ...rest } = props;
  const styles = {
    ...useStyleConfig('Button', { size: 'sm' }),
    ...useStyleConfig('ColorButton', { colorScheme }),
  };

  const properties: ChakraButtonProps = {
    __css: styles,
    as,
    isDisabled,
    isLoading,
    ...rest,
  };
  if (isDisabled) {
    properties.as = 'button';
  }
  return <ChakraButton {...properties} ref={ref} size="sm" />;
});

export default ColorButton;
